import { makeScopedSettings } from './makeScopedSettings';
import { CoherenceV9DarkTheme } from '@coherence-design-system/styles';
/**
 * Special darker blue for Primary items which has a stronger contrast
 * when combined with white text.
 */
export const darkThemeBlue = '#2866DE';
/** Generator for the MSRC official dark theme */
export const msrcDarkCustomizations = () => {
    const darkTheme = CoherenceV9DarkTheme;
    darkTheme.semanticColors.primaryButtonBackground = darkThemeBlue;
    darkTheme.components = makeScopedSettings(CoherenceV9DarkTheme, true);
    return darkTheme;
};
